import { render, staticRenderFns } from "./buyer-information-index.vue?vue&type=template&id=a159a5ce"
import script from "./buyer-information-index.vue?vue&type=script&lang=js"
export * from "./buyer-information-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports